// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-100[data-v-cb0bde1e]{height:100%!important}.bg-light[data-v-cb0bde1e]{background-color:hsla(0,0%,97.6%,.5058823529411764)}.iframe-wrapper[data-v-cb0bde1e]{position:relative;width:100%;padding-bottom:56.25%;background-color:#000;border-top:1px solid #eee;border-bottom:1px solid #eee}.cover[data-v-cb0bde1e]{height:30px;background:rgba(211,209,209,.30196078431372547)!important;border-radius:5px!important}", ""]);
// Exports
module.exports = exports;
